import React, { useState,useEffect } from "react";
import api from "views/auth/Api";
import "../../myProjects/Myprojects.css"
import {columnsDataComplex} from "../../tables/variables/columnsData";
import ModelsTable from "../../tables/components/ModelsTable";
import { TbFile3D } from "react-icons/tb";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { FiEdit } from "react-icons/fi";




const LibraryPrint = () => {

      const [tableData , setTableData] = useState([]); 
      const [selected, setSelected] = useState(null);
    
        const token = localStorage.getItem('token');
        const decoded = jwtDecode(token);
        const role = decoded.role;    

      const { id } = useParams();
      const navigate = useNavigate();    

     useEffect(() => {
     api.get(`${API_BASE_URL}library/${id}`)
      .then((response) => {  
        if (!response.data) {
          navigate(`/auth/not-found/`);
        }
        setTableData(response.data?.model3d?.modelParts)

      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [navigate,id]);

      const selectPlate =(id)=>{
      setSelected(id);
        console.log("Selected Plate ID:", id);
      }

  return (
    <div>
        <div className="libraryHeader">
          <div className="libraryH">
          <h1>3D Models Library</h1>
{role === "Admin" ?  <Link to={`/admin/tr/challenges/edit/${id}`}><div className="newChallenge">
                     <FiEdit className="addImg"/>
                     <span>Edit Library</span>
                    </div></Link>
                    : null}          
                    </div>
          <div className="libraryheaderImg"></div>
        </div>
      <div className="model3d-container"> 
        <div className="model3d-cards" >
           {tableData.map(img =>
                      <div className= {selected === img.id ? "model3d-cardSelected" : "model3d-card"} style={{backgroundImage:`url(${FILES_URL}${img.img?.url})`}}>
                      </div>
                   )}
        </div>
  <div className="table3D">
        <ModelsTable
          columnsData={columnsDataComplex}
          tableData={tableData}
          selectPlate ={selectPlate}
        />
     <div className="print3D"><TbFile3D className="printIcon"/><span>Print</span></div>
   </div>
   
        </div>
    </div>
  );
};

export default LibraryPrint;
